import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { levelFor } from "../lib/levels";
import { toast } from "sonner";

export default function Journal() {
  const { user, setUser } = useAuth();
  const lvl = levelFor(user?.current_level || 1);
  const [text, setText] = useState("");
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/journal");
      setItems(data.items);
    } catch (err) {
      console.error("journal load failed:", err);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const submit = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post("/journal", { text });
      setText("");
      await load();
      try { const { data } = await api.get("/auth/me"); setUser(data); } catch (err) { console.error("user refresh failed:", err); }
      toast.success("+15 XP · Curiosity +1");
    } catch { toast.error("Couldn't save."); }
    setBusy(false);
  };

  return (
    <div className="animate-fadeUp" data-testid="journal-page">
      <div className="text-xs font-bold uppercase tracking-[0.25em] opacity-60">Daily rep</div>
      <h1 className="font-display font-black text-4xl tracking-tighter mt-2">Honest line</h1>
      <p className="opacity-70 mt-2 max-w-xl">One line is enough. Whatever's true right now.</p>

      <div className="mt-8 rounded-3xl p-7 shadow-lg border border-[#0e203b]/5" style={{ backgroundColor: lvl.surface }}>
        <textarea
          data-testid="journal-text"
          value={text}
          onChange={e => setText(e.target.value)}
          rows={4}
          placeholder="Today I noticed…"
          className="w-full p-4 rounded-2xl border-2 border-[#0e203b]/10 focus:border-[#0e203b] outline-none font-medium bg-white resize-none"
        />
        <div className="flex justify-end mt-4">
          <button onClick={submit} disabled={busy || !text.trim()} data-testid="journal-submit" className="btn-pill bg-[#0e203b] text-white rounded-full px-6 h-12 font-bold disabled:opacity-40">
            {busy ? "Saving…" : "Save entry"}
          </button>
        </div>
      </div>

      {items.length > 0 && (
        <div className="mt-8 space-y-3">
          {items.map(i => (
            <div key={i.id} className="bg-white rounded-2xl p-5 border border-[#0e203b]/5" data-testid="journal-item">
              <div className="text-xs opacity-60">{new Date(i.created_at).toLocaleString()}</div>
              <div className="mt-1 whitespace-pre-wrap">{i.text}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
